import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Supplier } from "../state/types"

export const useSupplierActions = () => {
    const saveActions = useSaveActions()

    const saveSupplier = (supplier: Supplier) => {
        const { save } = saveActions()
        return save(TableName.SUPPLIERS, supplier) as Promise<Supplier>
    }

    const saveSuppliers = (suppliers: Supplier[]) => {
        const { saveMultiple } = saveActions()
        return saveMultiple(TableName.SUPPLIERS, suppliers)
    }

    const removeSupplier = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.SUPPLIERS, id)
    }

    return {
        saveSupplier,
        saveSuppliers,
        removeSupplier
    }
}
